(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('ResponsibilityFranchiserFormController', ResponsibilityFranchiserFormController)

    /** @ngInject */
    function ResponsibilityFranchiserFormController($state, $stateParams, LoadingHelper, UtilHelper, sweetAlert, ResponsibilityService) {
        const vm = this;
        const responsibilityId = $stateParams.responsibilityId;

        vm.saveResponsibilty = () => {
            LoadingHelper.startLoading('.loading-holder');

            if (!vm.responsibilityData.Id) {
                ResponsibilityService
                    .post(vm.responsibilityData)
                    .then(success => successCallback(success, true), errorCallback);
            } else {
                let responsibilityData = {
                    Id: responsibilityId,
                    ExternalCode: vm.responsibilityData.ExternalCode,
                    Description: vm.responsibilityData.Description
                };

                ResponsibilityService
                    .put(responsibilityData)
                    .then(success => successCallback(success, false), errorCallback);
            }
        }

        vm.deleteResponsibility = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    LoadingHelper.startLoading('.loading-holder');

                    ResponsibilityService
                        .deleteData(responsibilityId)
                        .then(() => {
                            $state.go('app.franchiser-responsibilities-list')
                            LoadingHelper.stopLoading('.loading-holder');
                            UtilHelper.successCallback('delete');
                        }, error => {
                            UtilHelper.errorCallback(error);
                            LoadingHelper.stopLoading('.loading-holder');
                        })
                }
            })
        }

        init();

        function getResponsibility() {
            if (!responsibilityId)
                return;

            LoadingHelper.startLoading('.loading-holder');

            ResponsibilityService
                .get(responsibilityId)
                .then(success => {
                    vm.responsibilityData = success;
                    LoadingHelper.stopLoading('.loading-holder');
                }, error => {
                    LoadingHelper.stopLoading('.loading-holder');
                    UtilHelper.errorCallback(error);
                })
        }

        function successCallback(success, isPost) {
            if (isPost) {
                vm.responsibilityData = success;

                $state.go('app.franchiser-responsibilities-edit', {
                    responsibilityId: vm.responsibilityData.Id
                }, {
                    notify: false
                });

                UtilHelper.successCallback('create');
            } else {
                UtilHelper.successCallback('update');
            }

            LoadingHelper.stopLoading('.loading-holder');
        }

        function errorCallback(error) {
            LoadingHelper.stopLoading('.loading-holder');
            UtilHelper.errorCallback(error);
        }

        function init() {
            vm.responsibilityData = {};

            getResponsibility();
        }
    }
}());